<template>
    <div>
        <b-modal
            :id="modalId"
            :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]"
            modal-class="modal-no-internet"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base"
                :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                <div class="modal-base-img">
                    <img class="modal-base-img-warning" src="@/assets/images/modal/img-warning-modal.png" alt="img-warning-modal">
                </div>
                <div class="modal-base-body">
                    <p id="no_internet_txt" v-html="msg"></p>
                </div>
                <div class="modal-base-footer">
                    <PrimaryButton
                        btnId="no-internet-modal__button-primary"
                        :btnMsg="lbl.default.retry"
                        @clickButton="clickRetry()" />
                    <SecondaryButton
                        btnId="no-internet-modal__button-secondary"
                        :btnMsg="lbl.default.cancel"
                        @clickButton="clickCancel()" />

                    <!-- <div class="btn-clean-wrapper"
                        :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                        <div class="btn-txt"
                            @click="clickRetry()">
                            {{btnClose}}
                        </div>
                    </div> -->
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import PrimaryButton from "@/components/Button/PrimaryButton.vue";
import SecondaryButton from "@/components/Button/SecondaryButton.vue";
export default {
    name: 'NoInternetModal',
    mixins: [LocaleMixin],
    components: {
        PrimaryButton,
        SecondaryButton
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            msg: '',
            tag: '',
            btnClose: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickRetry: function () {
            this.hide();
            this.controller.cbClose.sendCallback({tag: this.tag});
        },
        clickCancel: function () {
            this.hide();
            this.controller.cbClose.sendCallback({tag: this.tag});
        },
        show: function(config) {
            this.msg = config.msg;
            this.tag = config.tag;
            this.btnClose = config.btnClose;

            if (Util.isEmptyStr(config.msg))
                this.msg = this.lbl.default.no_internet;

            if (Util.isEmptyStr(config.btnClose))
                this.btnClose = this.lbl.default.retry;

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#no_internet_txt {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: $color-gray;
    margin-bottom: 16px;
}

.btn-clean-wrapper {
    @include btn-clean-wrapper(100%);
    border: 1px solid $color-gray-4;
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-no-internet {
    @extend %modal-base;

    .modal-dialog {
       max-width: 300px;     
    }

    .modal-base-img {
        margin: 0 auto 16px auto;
        display: flex;
        justify-content: center;
        align-items: center;

        .modal-base-img-warning {
            width: 144px;
            height: 100%;
            margin: 0 auto;
        }
    }

    .modal-base-footer {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
}
</style>
